import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '95%',
      '& .MuiDialog-paper': {
        borderRadius: '10px',
        overflowY: 'inherit',
      },
      '& .MuiDialogContent-root': {
        overflowY: 'auto',
        '&::scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-moz-scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar-thumb': {
          width: '0',
          minWidth: '0',
        },
      },
      '& .MuiDialogActions-root': {
        display: 'flex',
        flexDirection: ' row-reverse',
        gap: '15px',
        padding: '16px',
        justifyContent: 'flex-start',
      },
      '& .MuiDialog-container': {
        width: '100vw',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
    },
    content: {
      minWidth: 500,
      padding: '20px 25px 25px !important',
      [theme.breakpoints.down('sm')]: {
        minWidth: 'auto',
        padding: '12px 20px !important',
      },
    },
    actions: {
      display: 'flex',
      flexDirection: 'row-reverse',
      gap: '15px',
      padding: '20px 20px 22px',
    },
  };
});
